export default "__VITE_ASSET__CwV$Go2o__"